<template>
  <div class="w-full">
    <SparkMultiFilter
      name="pipeline-status"
      label="Pipeline Status"
      placeholder="Select pipeline status"
      :options="pipelineStatusOptions"
      v-model="selectedPipelineStatusValues"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SparkMultiFilter from '@/components/SparkComponents/SparkMultiFilter.vue';

export default {
  name: 'PipelineStatusFilter',

  components: {
    SparkMultiFilter,
  },

  props: {
    reset: { type: Number, required: true },
    parent: { type: String, required: true },
  },

  emits: ['selected'],

  data() {
    return {
      selectedPipelineStatusValues: [],
      pipelineStatusOptions: [],
    };
  },

  computed: {
    ...mapState(['partLibraryFilters', 'pipeline']),
    ...mapState('application', ['axiosInstance']),
  },

  watch: {
    selectedPipelineStatusValues: {
      handler(newVal) {
        this.$emit('selected', { pipeline_status: newVal });
      },
    },

    pipeline: {
      handler() {
        if (this.pipeline) {
          this.pipelineStatusOptions = this.pipeline.map(entry => ({
            value: entry.uid,
            label: entry.name,
            orderIndex: entry.order_index,
          }));
        }
      },
      immediate: true,
    },

    reset: {
      handler() {
        if (this.reset) {
          this.clear();
        }
      },
    },
  },

  async mounted() {
    const filter = JSON.parse(sessionStorage.getItem('libraryFilter'));
    if (this.parent === 'library') {
      const selected = filter?.pipeline_status;
      if (selected?.length) {
        this.selectedPipelineStatusValues = selected;
      }
    }
  },

  methods: {
    ...mapMutations(['resetFilter']),

    clear() {
      this.resetFilter({ pipelineStatus: 'pipelineStatus' });
      this.selectedPipelineStatusValues = [];
    },
  },
};
</script>

<style scoped lang="scss">
</style>
